import type { KpiId } from './consumption.model';

/**
 * Hardcoded included resources per limited subscription plan, keyed by the
 * Payment billing state ('indie' is the backend name and what the console now shows).
 *
 * These numbers are NOT delivered by the Payment API — they mirror the
 * public pricing page and MUST stay in sync with the display strings in
 * `modules/admin/app-settings/plan-panel/plan.model.ts` (`FEATURE_CATEGORIES`).
 *
 * Notes:
 * - Fleet keys remain the advertised-plan fallback used by Fleet Analytics.
 *   The header, Usage & Costs, and Fleet App page use the app's actual CPUH*
 *   and RAMH* wallets instead; a negotiated or newly changed grant must never
 *   be replaced by this static table.
 * - `cortex.transcription-minutes` on Trial is an **overall** allowance
 *   (10 minutes total, not per month); the meter tracks the current
 *   billing period, so usage from earlier months isn't counted against it.
 * - `cortex.sessions` is a **concurrent** bot-session allowance, not a
 *   monthly quota — it is rendered as an informational note, never as a
 *   percent bar (the metrics API only exposes sessions *started*).
 * - Mini does not include Cortex, hence no cortex entries.
 */
export const PLAN_INCLUDED_LIMITS: Record<
  'free' | 'mini' | 'indie',
  Partial<Record<KpiId, number>>
> = {
  free: {
    'voice.pcu': 25,
    'fleet.cpu-hours': 1440,
    'fleet.memory-gb-hours': 2880,
    'cortex.transcription-minutes': 10,
    'cortex.sessions': 1,
  },
  mini: {
    'voice.pcu': 100,
    'fleet.cpu-hours': 4320,
    'fleet.memory-gb-hours': 8640,
  },
  indie: {
    'voice.pcu': 500,
    'fleet.cpu-hours': 14400,
    'fleet.memory-gb-hours': 28800,
    'cortex.sessions': 50,
  },
};
